import React from "react"

import { FloorFormTabType } from "features/floor-management/types/FloorFormTabType"

import { EditFloorOverlay } from "./EditFloorOverlay"
import { useEditFloorOverlayModel } from "./hooks/useEditFloorOverlayModel"

export interface EditFloorOverlayPayload {
  projectID: string
  floorID: string
  defaultTab?: FloorFormTabType
}

export interface EditFloorOverlayConnectorProps {
  payload: EditFloorOverlayPayload
}

export const EditFloorOverlayConnector = React.memo(
  (props: EditFloorOverlayConnectorProps) => {
    return <EditFloorOverlay autoFocus {...useEditFloorOverlayModel(props)} />
  }
)

EditFloorOverlayConnector.displayName = "EditFloorOverlayConnector"

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    EDIT_FLOOR_OVERLAY: EditFloorOverlayPayload
  }
}
